export default __webpack_public_path__ + "static/media/Snd_TryI.c51c31de.mp3";